import noop from 'lodash/noop';
import React from 'react';
import Filters from '../Filters/Filters';
import FiltersMobile from '../FiltersMobile/FiltersMobile';
import Pagination from '../Global/Pagination/Pagination';
import LoadingOverlay from '../LoadingOverlay/LoadingOverlay';
// import MemberDirectoryMap, {
//   LocationModel,
// } from '@stories/Widgets/MemberDirectoryMap/MemberDirectoryMap';
import S from './FilteredListing.styles';
function FilteredListing({ error, filtersProps, flush = 'top', items, listTitle, loading = false, pageSize = 12, pageIndex = 0, renderItems, totalItems = 0, onPageChange = noop, }) {
    const [visible, setVisible] = React.useState(false);
    const firstNum = pageIndex * pageSize - 11;
    const lastNum = firstNum + (items ? items?.length - 1 : 12);
    return (React.createElement(S.Container, { flush: flush },
        listTitle && React.createElement(S.ListTitle, null, listTitle),
        filtersProps && React.createElement(Filters, { ...filtersProps, visible: visible, setVisible: setVisible }),
        filtersProps && (React.createElement(FiltersMobile, { ...filtersProps, visible: visible, setVisible: setVisible })),
        loading && renderLoading(),
        error && renderError(error),
        items && renderResults(items)));
    function renderError(error) {
        return React.createElement(S.Message, null, error.message);
    }
    function renderLoading() {
        return React.createElement(LoadingOverlay, null);
    }
    function renderResults(items) {
        if (items.length === 0) {
            return React.createElement(S.Message, null, "No results.");
        }
        return (React.createElement(React.Fragment, null,
            renderItems(items),
            items.length < totalItems && (React.createElement(S.CtaWrapper, null,
                React.createElement(Pagination, { pageIndex: pageIndex, pageSize: pageSize, onPageChange: onPageChange, totalCount: totalItems }),
                React.createElement(S.ResultIndicator, null,
                    React.createElement(S.ResultIndicatorContent, null,
                        firstNum,
                        " - ",
                        lastNum,
                        " of ",
                        totalItems))))));
    }
}
export default FilteredListing;
